define('models/AddressModel',['underscore','ObjectModel','LocalStorage','router','app','ApiRequest','PlaceModel'],function (_,ObjectModel,LocalStorage,router,app,ApiRequest,PlaceModel) {
    //
    // Model Address
    //

    var FALLBACK = 'fallback',
        ID_NONE = 'none',
        fallbackTest = /^fallback_.+/,
        ADDRESS_TYPE_ICONS = ['tab-map','addr-home','addr-desk','addr-vacation','addr-people','addr-people'],
        ADDRESS_TYPE_LABELS = ['Personnaliser le nom de l’adresse','À la maison','Au travail','Maison de vacances','Chez des amis','Dans la famille'];

    var AddressModelPrototype = {

        name:'AddressModel',
        idAttribute:'id_address',
        route:'apiAddressModel',
        translated:false,
        defaults:{
            id_address:ID_NONE,
            fallback:ID_NONE,
            alias:'',
            company:'',
            numberbis:'',
            code:'',
            interphone:'',
            latitude:'',
            longitude:'',
            building:'',
            stair:'',
            floor:'',
            door:'',
            description:'',
            data:''
        },
        initialize:function(){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,arguments);
            //
            if(fallbackTest.test(model.id)){
                model.set('fallback',model.id);
            }
            model.on('change:id_address',function(){
                // lors du changement d'identifiant
                if(!app.getAddress(model.id)){
                    app.getAddresses().add(model);
                }
            });
            //this.on('all',this.allEvents,this);
        },
        getAlias:function(){
          return (this.get('alias') || '').trim();
        },
        getDescription:function(){
          return this.get('description');
        },
        getPostcode:function(){
            return this.get('postcode');
        },
        getData:function(){
            return this.get('data');
        },
        isLike:function(){
            return this.get('like')==1;
        },
        isPrimary:function(){
            return app.getCustomer().get('id_address_primary') == this.id;
        },
        getIdPostcode:function(){
            return this.get('id_postcode');
        },
        getPostcodeModel:function(){
            var postcode = app.getPostcode(this.getIdPostcode());
            return postcode ? postcode : app.getPostcodeByValue(this.getPostcode());
        },
        getDistrict: function () {
            var model = this, postcode = model.getPostcodeModel(), id_district = model.get('id_district');
            if (postcode) {
                return postcode.getDistrict(id_district);
            }
        },
        getCountryName:function(){
            var country = app.getCountry(this.get('id_country'));
            if(!country) country = app.getCountry();
            // si on a pas de nom de pays, on retourne un chaine vide.
            return country ? country.getName() : '';
        },
        smartReplacePostalCode:function(){
            // voir SSRST-16
            // en UK, pour remplacer les valeurs de code postaux "dégradées"
            // par les valeurs "réelles" fournies par Google
            var model = this,
                place = model.getPlace(),
                id_postcode = model.getIdPostcode(),
                postcode = model.getPostcodeModel(),
                addressInitialPostcode = model.getPostcode(),
                postal_code;
            try{
                if(!id_postcode && (postcode.getPostcode() == addressInitialPostcode)){
                    //
                    // Si il n'y a pas d'id_postcode
                    // et que les valeurs sont redondantes entre address et postcode
                    //
                    if(place){
                        postal_code = place.get('postal_code');
                        function SmartReplace(){
                            model.set({
                                id_postcode:postcode.id,
                                postcode:postal_code ? postal_code : addressInitialPostcode
                            });
                            model.save();
                        }
                        if(postal_code){
                            SmartReplace();
                        }else{
                            place.once('sync',function(){
                                postal_code = place.get('postal_code');
                                SmartReplace();
                            });
                            place.remoteFetch();
                        }
                    }
                    //
                }
            }catch(err){
            }
        },
        hasPlace:function(){
            return !_.isUndefined(this.getPlace());
        },
        getPlace:function(){
            return PlaceModel.getPlace(this.get('place_id'),this);
        },
        getLatitude: function(){
            return parseFloat(this.get('latitude')) || 0;
        },
        getLongitude: function(){
            return parseFloat(this.get('longitude')) || 0;
        },

        formatAliasLabel:function(ignoreEmpty)
        {
            // affiche l'adresse réelle si elle n'est pas identique à l'alias
            var model = this,
                alias = model.getAlias();
            if(!alias & !ignoreEmpty){
                alias = app.t('Adresse à %s','Address',model.get('city'));
            }
            return alias;
        },

        formatIcon:function(){
            return '<i class="icon-'+this.getIcon()+'"></i>';
        },

        getIcon:function(){
            var model = this;
            return getIcon(model.get('type'));
        },

        formatAutocompleteStreetAddress:function(){
            var model = this,
                description = model.getDescription(),
                label = description;
            if(!label){
                label = model.formatFullAddress('autocomplete');
            }
            return label;
        },

        formatAliasStreetAddress:function(onlyStreetAddress, reorder){
            // affiche l'adresse réelle si elle n'est pas identique à l'alias
             var model = this,
                 alias = model.getAlias(),
                 description = model.getDescription(),
                 label = onlyStreetAddress ? '':alias;


            if (reorder)
            {
                var data = model.formatFullAddress();
                label  =  data;
            }
            else if(alias != description){
                label = description ||  alias;
            }else if (label == '')
            {
            //  label =  description;

            }

            return label;
        },
        isDeleted:function(){
            return this.get('deleted') == 1;
        },
        formatAddressOptions:function(){
            var model = this,
                postcode = model.getPostcodeModel(),
                id_district = model.get('id_district'),
                place = model.getPlace(),
                deliveryOptions = model.pick('id_district','id_postcode','postcode','street','number','latitude','longitude'),
                latitude = deliveryOptions.latitude,
                longitude = deliveryOptions.longitude,
                ignore_geo_validation = !latitude && !longitude ? 1 : 0,
                options = _.defaults(
                    {
                        vae:0,
                        ignore_geo_validation:ignore_geo_validation,
                        id_address_delivery:model.id
                    },
                    deliveryOptions
                );
            if(ignore_geo_validation){
                if(postcode) options['id_postcode'] = postcode.id;
                if(id_district) options['id_district'] = id_district;
            }else{
                options.postcode = deliveryOptions.postcode;
            }
            if(place && place.isGooglePlace() && postcode){
                options.postcode = place.getPostalCode();
                var id_district = place.getDistrictId();
                if(id_district){
                    options.id_district = id_district;
                }
                options.place_id = place.id;
                deliveryOptions = _(deliveryOptions).defaults(place.toJSON());
            }else if(postcode){
                deliveryOptions = model.toJSON()
            }
            return {options:options,deliveryOptions:deliveryOptions};
        },
        attachToCart:function(){
            var options = this.formatAddressOptions();
            app.getCart().setDeliveryOptions(options.options,options.deliveryOptions);
        },
        allEvents:function(eventType){
        },
        isNew:function(){
            // convention, pour instancier une adresse nouvelle, on lui affecte l’id 'new'
            var id = this.id;
            return id === 'new' || id === ID_NONE || id === FALLBACK || fallbackTest.test(id);
        },
        formatFullAddress:function(format){
            var address = this,
                separator = app.getAddressSeparator(),
                number = address.get('number'),
                fullStreet =  (number?number+separator:'')+ address.get('street'),
                district = address.getDistrict(),
                city = address.get('city'),
                ignorePostcode = app.c('_MOD_POSTCODE_') !== 'ignore_postcode',
                fullCity = (ignorePostcode ? address.get('postcode') : district ? district.name+separator:'') +' '+ city;
            switch(format){
                case 'fullStreet':
                    return fullStreet;
                case 'fullCity':
                    return fullCity;
                case 'autocomplete':
                    return fullStreet+city;
                default:
                    return fullStreet+separator+fullCity;
            }
        }
    };

    var AddressModel = ObjectModel
        .extend(LocalStorage)
        .extend(AddressModelPrototype);

    function getIcon(type){
        return ADDRESS_TYPE_ICONS[type]||ADDRESS_TYPE_ICONS[0];
    };
    function getAliasLabel(type){
        return app.t(ADDRESS_TYPE_LABELS[type]||ADDRESS_TYPE_LABELS[0],'Address');
    };
    AddressModel.getIcon = getIcon;
    AddressModel.getAliasLabel = getAliasLabel;
    AddressModel.getIconTypes = function(){
        return _(ADDRESS_TYPE_ICONS).map(function(icon,index){
            return {
                id:index,
                icon:icon,
                label:app.t(ADDRESS_TYPE_LABELS[index],'Address')
            }
        });
    };

        // Permet d'instancier un modèle d'adresse à partir d'un PlaceModel
    AddressModel.createAddressFromPlace = function(place,attach_to_cart,data,customer_primary,source){
        //
        // créé une adresse à partir d'une place_id
        //
        var modelOptions = {id_address:'empty_address',alias:'-'}; // default options
        if(place) {
            //
            modelOptions = place.getCartOptions();
            //
            modelOptions.attach_to_cart = attach_to_cart;
            // data correspond aux compléments d'adresse
            if (data) {
                modelOptions.data = data;
            }
            // primary // par défaut, on set le primary
            if (customer_primary || app.hasNotCustomerPrimaryAddress()) {
                modelOptions.customer_primary = 1;
            }
        }
        modelOptions.source = source || 0;

        return new AddressModel(modelOptions);

    };

    return AddressModel;
});
